// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/payments/firstparty/v5/payment.proto

/* eslint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";
import { ApiCurrencyAmount } from "../../../../../common/payment";
import { ApiPaymentInitiator } from "../../../firstparty/v4/payment_link";

/** Enum for payment status */
export const ApiPaymentStatus = {
  /** PAYMENT_STATUS_UNSPECIFIED - Payment status Default unspecified value */
  PAYMENT_STATUS_UNSPECIFIED: "PAYMENT_STATUS_UNSPECIFIED",
  /** PAYMENT_STATUS_OPEN - Payment is open */
  PAYMENT_STATUS_OPEN: "PAYMENT_STATUS_OPEN",
  /** PAYMENT_STATUS_PROCESSING - Payment is processing */
  PAYMENT_STATUS_PROCESSING: "PAYMENT_STATUS_PROCESSING",
  /** PAYMENT_STATUS_COMPLETED - Payment is completed */
  PAYMENT_STATUS_COMPLETED: "PAYMENT_STATUS_COMPLETED",
  /** PAYMENT_STATUS_FAILED - Payment failed */
  PAYMENT_STATUS_FAILED: "PAYMENT_STATUS_FAILED",
  /** PAYMENT_STATUS_EXPIRED - Payment expired */
  PAYMENT_STATUS_EXPIRED: "PAYMENT_STATUS_EXPIRED",
  /** PAYMENT_STATUS_CANCELED - Payment canceled */
  PAYMENT_STATUS_CANCELED: "PAYMENT_STATUS_CANCELED",
} as const;

export type ApiPaymentStatus = typeof ApiPaymentStatus[keyof typeof ApiPaymentStatus];

export namespace ApiPaymentStatus {
  export type PAYMENT_STATUS_UNSPECIFIED = typeof ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
  export type PAYMENT_STATUS_OPEN = typeof ApiPaymentStatus.PAYMENT_STATUS_OPEN;
  export type PAYMENT_STATUS_PROCESSING = typeof ApiPaymentStatus.PAYMENT_STATUS_PROCESSING;
  export type PAYMENT_STATUS_COMPLETED = typeof ApiPaymentStatus.PAYMENT_STATUS_COMPLETED;
  export type PAYMENT_STATUS_FAILED = typeof ApiPaymentStatus.PAYMENT_STATUS_FAILED;
  export type PAYMENT_STATUS_EXPIRED = typeof ApiPaymentStatus.PAYMENT_STATUS_EXPIRED;
  export type PAYMENT_STATUS_CANCELED = typeof ApiPaymentStatus.PAYMENT_STATUS_CANCELED;
}

export function apiPaymentStatusFromJSON(object: any): ApiPaymentStatus {
  switch (object) {
    case 0:
    case "PAYMENT_STATUS_UNSPECIFIED":
      return ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
    case 1:
    case "PAYMENT_STATUS_OPEN":
      return ApiPaymentStatus.PAYMENT_STATUS_OPEN;
    case 2:
    case "PAYMENT_STATUS_PROCESSING":
      return ApiPaymentStatus.PAYMENT_STATUS_PROCESSING;
    case 3:
    case "PAYMENT_STATUS_COMPLETED":
      return ApiPaymentStatus.PAYMENT_STATUS_COMPLETED;
    case 4:
    case "PAYMENT_STATUS_FAILED":
      return ApiPaymentStatus.PAYMENT_STATUS_FAILED;
    case 5:
    case "PAYMENT_STATUS_EXPIRED":
      return ApiPaymentStatus.PAYMENT_STATUS_EXPIRED;
    case 6:
    case "PAYMENT_STATUS_CANCELED":
      return ApiPaymentStatus.PAYMENT_STATUS_CANCELED;
    default:
      return ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED;
  }
}

export function apiPaymentStatusToJSON(object: ApiPaymentStatus): string {
  switch (object) {
    case ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED:
      return "PAYMENT_STATUS_UNSPECIFIED";
    case ApiPaymentStatus.PAYMENT_STATUS_OPEN:
      return "PAYMENT_STATUS_OPEN";
    case ApiPaymentStatus.PAYMENT_STATUS_PROCESSING:
      return "PAYMENT_STATUS_PROCESSING";
    case ApiPaymentStatus.PAYMENT_STATUS_COMPLETED:
      return "PAYMENT_STATUS_COMPLETED";
    case ApiPaymentStatus.PAYMENT_STATUS_FAILED:
      return "PAYMENT_STATUS_FAILED";
    case ApiPaymentStatus.PAYMENT_STATUS_EXPIRED:
      return "PAYMENT_STATUS_EXPIRED";
    case ApiPaymentStatus.PAYMENT_STATUS_CANCELED:
      return "PAYMENT_STATUS_CANCELED";
    default:
      return "PAYMENT_STATUS_UNSPECIFIED";
  }
}

/** Enum for payment methods */
export const ApiPaymentMethod = {
  /** PAYMENT_METHOD_UNSPECIFIED - Default unspecified value for unknown or unrecognized payment method */
  PAYMENT_METHOD_UNSPECIFIED: "PAYMENT_METHOD_UNSPECIFIED",
  /** PAYMENT_METHOD_CREDIT_CARD - Credit card payment method */
  PAYMENT_METHOD_CREDIT_CARD: "PAYMENT_METHOD_CREDIT_CARD",
  /** PAYMENT_METHOD_APPLE_PAY - Apple Pay payment method */
  PAYMENT_METHOD_APPLE_PAY: "PAYMENT_METHOD_APPLE_PAY",
  /** PAYMENT_METHOD_PAYPAL - PayPal payment method */
  PAYMENT_METHOD_PAYPAL: "PAYMENT_METHOD_PAYPAL",
  /** PAYMENT_METHOD_IDEAL - iDEAL payment method */
  PAYMENT_METHOD_IDEAL: "PAYMENT_METHOD_IDEAL",
} as const;

export type ApiPaymentMethod = typeof ApiPaymentMethod[keyof typeof ApiPaymentMethod];

export namespace ApiPaymentMethod {
  export type PAYMENT_METHOD_UNSPECIFIED = typeof ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  export type PAYMENT_METHOD_CREDIT_CARD = typeof ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD;
  export type PAYMENT_METHOD_APPLE_PAY = typeof ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY;
  export type PAYMENT_METHOD_PAYPAL = typeof ApiPaymentMethod.PAYMENT_METHOD_PAYPAL;
  export type PAYMENT_METHOD_IDEAL = typeof ApiPaymentMethod.PAYMENT_METHOD_IDEAL;
}

export function apiPaymentMethodFromJSON(object: any): ApiPaymentMethod {
  switch (object) {
    case 0:
    case "PAYMENT_METHOD_UNSPECIFIED":
      return ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
    case 1:
    case "PAYMENT_METHOD_CREDIT_CARD":
      return ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD;
    case 2:
    case "PAYMENT_METHOD_APPLE_PAY":
      return ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY;
    case 3:
    case "PAYMENT_METHOD_PAYPAL":
      return ApiPaymentMethod.PAYMENT_METHOD_PAYPAL;
    case 4:
    case "PAYMENT_METHOD_IDEAL":
      return ApiPaymentMethod.PAYMENT_METHOD_IDEAL;
    default:
      return ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  }
}

export function apiPaymentMethodToJSON(object: ApiPaymentMethod): string {
  switch (object) {
    case ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED:
      return "PAYMENT_METHOD_UNSPECIFIED";
    case ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD:
      return "PAYMENT_METHOD_CREDIT_CARD";
    case ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY:
      return "PAYMENT_METHOD_APPLE_PAY";
    case ApiPaymentMethod.PAYMENT_METHOD_PAYPAL:
      return "PAYMENT_METHOD_PAYPAL";
    case ApiPaymentMethod.PAYMENT_METHOD_IDEAL:
      return "PAYMENT_METHOD_IDEAL";
    default:
      return "PAYMENT_METHOD_UNSPECIFIED";
  }
}

/** Message for a payment */
export interface ApiPayment {
  /** Payment ID */
  readonly id: string;
  /** Payment status */
  readonly status: ApiPaymentStatus;
  /** Payment method used */
  readonly paymentMethod: ApiPaymentMethod;
  /** Payment amount */
  readonly amount:
    | ApiCurrencyAmount
    | null;
  /** Payment completion timestamp */
  readonly paidAt?:
    | Date
    | null
    | undefined;
  /**
   * payment settlement timestamp.
   * It represents the actual timestamp when the payment was settled, if available.
   * otherwise it is the estimated settlement date.
   */
  readonly settledAt?:
    | Date
    | null
    | undefined;
  /** payment link */
  readonly paymentLink:
    | ApiPaymentLink
    | null;
  /** payer information */
  readonly payer:
    | ApiPayer
    | null;
  /** payment amount that will be settled */
  readonly settlementAmount?:
    | ApiCurrencyAmount
    | null
    | undefined;
  /** deductions */
  readonly deductions: ApiDeductions | null;
}

/** Message for a payment link */
export interface ApiPaymentLink {
  /** Payment link ID */
  readonly id: string;
  /** Payment link name */
  readonly name: string;
  /** Payment initiator information */
  readonly paymentInitiator: ApiPaymentInitiator | null;
}

/** Message for a payer */
export interface ApiPayer {
  /** Payer email */
  readonly email?:
    | string
    | null
    | undefined;
  /** Payer full name (can be null) */
  readonly fullName?: string | null | undefined;
}

/** Message for deductions */
export interface ApiDeductions {
  /**
   * fees deduction amount.
   * If amount is 0, then the value provided is null.
   */
  readonly fees?:
    | ApiCurrencyAmount
    | null
    | undefined;
  /**
   * reservations deduction amount
   * If amount is 0, then the value provided is null.
   */
  readonly reservations?:
    | ApiCurrencyAmount
    | null
    | undefined;
  /**
   * commissions deduction amount
   * If amount is 0, then the value provided is null.
   */
  readonly commissions?:
    | ApiCurrencyAmount
    | null
    | undefined;
  /**
   * repayments deduction amount
   * If amount is 0, then the value provided is null.
   */
  readonly repayments?: ApiCurrencyAmount | null | undefined;
}

export const ApiPayment: MessageFns<ApiPayment> = {
  fromJSON(object: any): ApiPayment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      status: isSet(object.status)
        ? apiPaymentStatusFromJSON(object.status)
        : ApiPaymentStatus.PAYMENT_STATUS_UNSPECIFIED,
      paymentMethod: isSet(object.payment_method)
        ? apiPaymentMethodFromJSON(object.payment_method)
        : ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED,
      amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null,
      paidAt: isSet(object.paid_at) ? fromJsonTimestamp(object.paid_at) : null,
      settledAt: isSet(object.settled_at) ? fromJsonTimestamp(object.settled_at) : null,
      paymentLink: isSet(object.payment_link) ? ApiPaymentLink.fromJSON(object.payment_link) : null,
      payer: isSet(object.payer) ? ApiPayer.fromJSON(object.payer) : null,
      settlementAmount: isSet(object.settlement_amount) ? ApiCurrencyAmount.fromJSON(object.settlement_amount) : null,
      deductions: isSet(object.deductions) ? ApiDeductions.fromJSON(object.deductions) : null,
    };
  },

  toJSON(message: ApiPayment): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiPaymentStatusToJSON(message.status);
    }
    if (message.paymentMethod !== undefined && message.paymentMethod !== null) {
      obj.payment_method = apiPaymentMethodToJSON(message.paymentMethod);
    }
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    if (message.paidAt !== undefined && message.paidAt !== null) {
      obj.paid_at = message.paidAt.toISOString();
    }
    if (message.settledAt !== undefined && message.settledAt !== null) {
      obj.settled_at = message.settledAt.toISOString();
    }
    if (message.paymentLink !== undefined && message.paymentLink !== null) {
      obj.payment_link = ApiPaymentLink.toJSON(message.paymentLink);
    }
    if (message.payer !== undefined && message.payer !== null) {
      obj.payer = ApiPayer.toJSON(message.payer);
    }
    if (message.settlementAmount !== undefined && message.settlementAmount !== null) {
      obj.settlement_amount = ApiCurrencyAmount.toJSON(message.settlementAmount);
    }
    if (message.deductions !== undefined && message.deductions !== null) {
      obj.deductions = ApiDeductions.toJSON(message.deductions);
    }
    return obj;
  },
};

export const ApiPaymentLink: MessageFns<ApiPaymentLink> = {
  fromJSON(object: any): ApiPaymentLink {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      paymentInitiator: isSet(object.payment_initiator) ? ApiPaymentInitiator.fromJSON(object.payment_initiator) : null,
    };
  },

  toJSON(message: ApiPaymentLink): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.paymentInitiator !== undefined && message.paymentInitiator !== null) {
      obj.payment_initiator = ApiPaymentInitiator.toJSON(message.paymentInitiator);
    }
    return obj;
  },
};

export const ApiPayer: MessageFns<ApiPayer> = {
  fromJSON(object: any): ApiPayer {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : null,
      fullName: isSet(object.full_name) ? globalThis.String(object.full_name) : null,
    };
  },

  toJSON(message: ApiPayer): unknown {
    const obj: any = {};
    if (message.email !== undefined && message.email !== null) {
      obj.email = message.email;
    }
    if (message.fullName !== undefined && message.fullName !== null) {
      obj.full_name = message.fullName;
    }
    return obj;
  },
};

export const ApiDeductions: MessageFns<ApiDeductions> = {
  fromJSON(object: any): ApiDeductions {
    return {
      fees: isSet(object.fees) ? ApiCurrencyAmount.fromJSON(object.fees) : null,
      reservations: isSet(object.reservations) ? ApiCurrencyAmount.fromJSON(object.reservations) : null,
      commissions: isSet(object.commissions) ? ApiCurrencyAmount.fromJSON(object.commissions) : null,
      repayments: isSet(object.repayments) ? ApiCurrencyAmount.fromJSON(object.repayments) : null,
    };
  },

  toJSON(message: ApiDeductions): unknown {
    const obj: any = {};
    if (message.fees !== undefined && message.fees !== null) {
      obj.fees = ApiCurrencyAmount.toJSON(message.fees);
    }
    if (message.reservations !== undefined && message.reservations !== null) {
      obj.reservations = ApiCurrencyAmount.toJSON(message.reservations);
    }
    if (message.commissions !== undefined && message.commissions !== null) {
      obj.commissions = ApiCurrencyAmount.toJSON(message.commissions);
    }
    if (message.repayments !== undefined && message.repayments !== null) {
      obj.repayments = ApiCurrencyAmount.toJSON(message.repayments);
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
